import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";
import { GetCampaignFieldsResponse } from "types/apiTypes";
import { RequestMethods } from "types/enums";

export const referencesApi = createApi({
  reducerPath: "referencesApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getCampaignFields: builder.query<GetCampaignFieldsResponse, void>({
      query: () => ({
        url: "/references/campaign_fields",
        method: RequestMethods.GET,
      }),
    }),
  }),
});

export const { useGetCampaignFieldsQuery } = referencesApi;
